import type {Access, AdminAccessUxState} from "../services/types.ts";

/** Legacy check responses without accessState: denied → bootstrap_choice, granted → admin.
 * Also maps pre-Phase-3 `bootstrap_key` during split deploys. */
export function resolveAccessState(access?: Access): AdminAccessUxState {
    if (access?.accessState) {
        const state = access.accessState as AdminAccessUxState | "bootstrap_key";
        return state === "bootstrap_key" ? "bootstrap_choice" : access.accessState;
    }
    if (access?.access === true) {
        return "admin";
    }
    return "bootstrap_choice";
}

export function shouldBlockOnAccessError(access: Access | undefined, accessError: Error | null | undefined): boolean {
    return accessError !== null && accessError !== undefined && access === undefined;
}

export function trialEnrollmentLimit(access?: Access): number | undefined {
    const limit = access?.planCapabilities?.maxConcurrentEnrollments;
    return typeof limit === "number" ? limit : undefined;
}
